import './Toast.less'

class Toast {
    static info(title = '人气太旺了，拜托稍等一下下，稍后再回来看看', time = 1000) {
        let query = document.querySelector('.ui-toast') || ''
        if (!query) {
            let container = document.createElement('div')
            container.innerHTML = title
            container.className = 'ui-toast'
            document.body.appendChild(container)
            setTimeout(() => {
                container.className = ''
                document.body.removeChild(container)
            }, time)
        }
    }
    static showLoading() {
        let query = document.querySelector('.ui-toast-loading-bgc') || ''
        if (!query) {
            let main = document.createElement('div')
            main.className = 'ui-toast-loading-bgc'
            let container = document.createElement('div')
            container.className = 'ui-toast-loading'

            main.appendChild(container)
            document.body.appendChild(main)
        }
    }
    static closeLoading() {
        let container = document.querySelector('.ui-toast-loading-bgc') || null
        if (container) {
            container.className = ''
            document.body.removeChild(container)
        }
    }
}

export default Toast



// WEBPACK FOOTER //
// ./src/common/Toast/Toast.js